export default {
  phoneForm: 'מספר טלפון',
  verificationForm: 'הזנת קוד',
  detailsForm: 'פרטים נוספים',
  errorMessages: { required: 'שדה חובה' },
  welcome1: 'סיימנו!',
  welcome2: 'מתחבר...'
};
